//import vimeo
import Player from '@vimeo/player';

jQuery(document).ready(function ($) {

    if (jQuery('.wp-block-embed-vimeo iframe').length > 0) {
        jQuery('.wp-block-embed-vimeo iframe').each(function () {
            var src = jQuery(this).attr('src');
            var options = {
                id: src,
            }
            let player = new Player(this, options);

            jQuery(player).data('time-watched', 0);
            player.on("timeupdate", function (data) {
                if (data.seconds - 1 < jQuery(player).data('time-watched') && data.seconds > jQuery(player).data('time-watched')) {
                    jQuery(player).data('time-watched', data.seconds);
                }
            });

            player.on("seeked", function (data) {
                //stop player
                player.pause();
                if (jQuery(this).data('time-watched') < data.seconds) {
                    var _this = this;
                    player.getVideoId().then(function (id) {
                        jQuery.ajax({
                            url: tr_frontend_vimeo.ajax_url,
                            type: 'POST',
                            data: {
                                action: 'tr_can_user_seek_video',
                                nonce: tr_frontend_vimeo.nonce,
                                video_id: id,

                            },
                            success: function (response) {
                                if (!response.success) {
                                    player.setCurrentTime(jQuery(_this).data('time-watched'));
                                    player.play();
                                }
                            }

                        })
                    })

                }
            });

            //when video is finished, save
            player.on('ended', function (data) {
                player.getVideoId().then(function (id) {
                    jQuery.ajax({
                        url: tr_frontend_vimeo.ajax_url,
                        type: 'POST',
                        data: {
                            action: 'tr_maybe_update_user_video_played_status',
                            nonce: tr_frontend_vimeo.nonce,
                            video_id: id,
                            status: 'completed'
                        },
                        success: function (response) {
                            //console.log(response);
                        }
                    });
                });



            });

            player.on('play', function (data) {
                player.getVideoId().then(function (id) {
                    //stop all other videso
                    jQuery('.wp-block-embed-vimeo iframe').each(function () {

                        var other_player = new Player(this);
                        if (other_player != player) {
                            other_player.pause();
                        }

                    });
                });
            }
            );

        });
    }
})